import { useHttpClient, IHttpClient } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';

type Props = {
  httpClient: IHttpClient;
};

export const withHttpClient = (Component: FC<Props>) => {
  return ((props) => {
    const httpClient = useHttpClient();

    return <Component {...props} httpClient={httpClient} />;
  }) as FC;
};
